<template>
    <div id="detail">
        <PlayerArea :isBuySet="true" :videoGid="videoGid"  :videoId="videoId" :viewList.sync="viewList" :viewInfo="videoInfo"
            :wxurl="shareUrl" />
        <InfoArea :briefArray="briefList" @transfer="toDetail" />
    </div>
</template>

<script>
import PlayerArea from "../Common/PlayerArea";
import InfoArea from "../Common/InfoArea";
import { Bus } from "../../tools/bus";

export default {
    name: "CourseDetail",
    data() {
        return {
            briefList: [],
            viewList: [],
            videoInfo: {},
            shareUrl: "http://app.orthoday.com/download_app.html",
            videoId: "",
            videoGid:"",

        };
    },
    components: { PlayerArea, InfoArea },
    watch: {
        "$route.params.gid": {
            handler(newVal) {
                location.reload();
            }
        }
    },
    computed: {
        gid() {
            return this.$route.params.gid || this.$route.query.gid;
        }
    },
    created() {
        this.gid && sessionStorage.setItem("c-gid", this.gid);
        let gid = this.gid || this.$route.params.gid || this.$route.params.gId || this.$route.query.gId || this.$route.query.gid || sessionStorage.getItem("c-gid");

        this.getCourseDetail(gid);
    },
    methods: {
        getCourseDetail(gid) {
            this.$axios
                .post("/web/course/queryCourseVideoNewList", this.$qs.stringify({ gid }))
                .then(res => {
                    let data = res.data;

                    if (data.code == 1) {
                        let arrayList = [],
                            dtArr = data.result_data;
                        let playInfo = dtArr[0];
                        this.briefList = dtArr[0].expert;

                        if (dtArr.length > 1) {
                            dtArr.map(item => {
                                arrayList = arrayList.concat(item.list);
                            });
                        } else {
                            arrayList = dtArr[0].list;
                        }
                        this.viewList = arrayList;

                        this.videoId = arrayList[0].videoId
                        this.videoGid = dtArr[0].courseGid;

                        // console.log("videoGid", this.videoGid)
                        // console.log("videoId", this.videoId)

                        let shareAddress = dtArr[0].shareAddress;
                        let reg = RegExp(/#wechat_redirect/),
                            regFlag = shareAddress.match(reg);
                        // this.shareUrl = regFlag
                        //   ? shareAddress
                        //   : `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc8fb10081c4a9f01&redirect_uri=${shareAddress}&response_type=code&scope=snsapi_base&state=123&connect_redirect=1#wechat_redirect`;

                        delete playInfo.expert;
                        delete playInfo.list;
                        this.videoInfo = playInfo;
                    } else if (data.code == 0 && !localStorage.getItem("token") || (data.code == 0 && data.message == "登录无效")) {
                        this.$message.warning("您未登录，请登录后观看！");
                        sessionStorage.setItem("RedirectPage", true);
                        setTimeout(() => {
                            Bus.$emit("setToken", false);
                            this.$router.push({ path: "/login" });
                        }, 1000);
                    } else {
                        this.$message.error(data.message);
                    }
                })
                .catch(err => console.log("err"));
        },
        toDetail(dic) {
            this.$router.replace({ name: "CourseDetail", params: { gid: dic }, query: { gid: dic } });
        }
    }
};
</script>

<style scoped>
#detail {
    margin: 0 auto;
    padding-top: 30px;
    width: 1200px;
    height: auto;
}
</style>
